export default __webpack_public_path__ + "static/media/g8.fc19fcef.jpg";